module.exports = require('./src/GettextWrapper');
